export default __webpack_public_path__ + "static/media/bb.1a6a02a6.png";